module.exports = __webpack_public_path__ + "img/logo.a96d6e73.png";